import { gql } from "@apollo/client";

export const FETCH_DOCUMENT_TREE = gql`
    query FetchDocumentsList($filter: DocumentFilterInput, $sort: DocumentSortInput, $chatMode: Boolean) {
        filteredDocuments(filter: $filter, sort: $sort, chatMode: $chatMode) {
            id
            name
            description
            reference
            version_major
            version_minor
            officialVersion
            category
            groupName
            hoverTitle
            amendsDocumentId
            amendsDocumentReference
            jurisdiction
            metadata
            isActiveForCompany
            rootContentNode {
                id
                name
                type
                hoverTitle
                metadata
                sizeInTokens
                sizeInPages
                isPromptable

                childNodes {
                    id
                    name
                    type
                    hoverTitle
                    metadata
                    sizeInTokens
                    sizeInPages
                    isPromptable

                    associatedOfficialDocument {
                        id
                        reference
                        name
                        category
                        hoverTitle
                        metadata
                        jurisdiction
                        isActiveForCompany
                    }

                    childNodes {
                        id
                        name
                        type
                        hoverTitle
                        metadata
                        sizeInTokens
                        sizeInPages
                        isPromptable

                        associatedOfficialDocument {
                            id
                            reference
                            name
                            category
                            hoverTitle
                            metadata
                            jurisdiction
                            isActiveForCompany
                        }
                    }
                }

                associatedOfficialDocument {
                    id
                    reference
                    name
                    category
                    hoverTitle
                    metadata
                    jurisdiction
                    isActiveForCompany
                }
            }
        }
    }
`;
